import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.issues.title',
        defaultMessage: 'Some information is missing or requires editing',
    },
    subtitle: {
        id: 'modal.issues.subtitle',
        defaultMessage:
            'To make corrections, please contact support or visit our <a target="_blank" href="#">Help page</a>',
    },
    ok: {
        id: 'modal.issues.ok',
        defaultMessage: 'Ok',
    },
    contact: {
        id: 'modal.issues.contact',
        defaultMessage: 'Contact support',
    },
})
